(function(window, document) {
  'use strict';

    document.querySelectorAll('.service-finder').forEach(function(element) {

        // Show second Level on button Click
        document.querySelectorAll('.service-finder_area-button').forEach(function(element) {
            element.addEventListener("click", (event) => {
                var target = element.dataset.target;
                hideServiceLevel('.service-finder_themes-target');

                calculateState(element);

                // activate next level
                document.getElementById(target).classList.add('service-finder_themes-target--active');
            });
        });

        // ajax-Request for Results service-finder_result-button
        document.querySelectorAll('.service-finder_result-button').forEach(function(element) {
            element.addEventListener("click", (event) => {
                var target = element.dataset.target;
                var url = window.location.protocol + "//" + window.location.host + target

                calculateState(element);

                // change headline
                var theme_title = element.textContent;
                document.querySelector("#result-wrapper .ce-header__title span").innerHTML = theme_title;

                // get Results
                getServiceElements(url, 'service-finder_results');
            });
        });

        // reset button
        document.querySelectorAll('.reset-button').forEach(function(element) {
            element.addEventListener("click", (event) => {
                var target = element.dataset.target;

                showSiblings(target);
                var current_level = element.closest('.service-finder__element');
                current_level.querySelector('.progress-decoration').classList.add('progress-decoration--active');
                hideLowerLevels(current_level);

                element.classList.remove('reset-button--active');
            });
        });
    });

})(window, document);

function calculateState(element) {
    var siblings = element.dataset.siblings;
    var nextLevel = element.dataset.next
    var currentLevel = element.dataset.parent;

    // activate clicked button
    element.classList.add(siblings + '--active');

    // hide buttons
    hideSiblings(element, siblings);

    // disable current level and enable next level (Decoration)
    recalcDecoration(currentLevel, nextLevel);

    // show reset button
    element.parentElement.querySelector('.reset-button').classList.add('reset-button--active');
}

function hideServiceLevel(targetclass) {
    document.querySelectorAll(targetclass).forEach(function(element) {
        element.classList.remove('service-finder_themes-target--active');

        // Empty Result-List
        hideResultLevel()

        // Deactivate Resultcontainer
        deactivateParent('service-finder_results');
    });
}

function hideResultLevel() {
    document.getElementById('service-finder_results').innerHTML = "";
    document.querySelector('#service-finder_result .ce-header__title span').innerHTML = "";
}

function hideLowerLevels(current_level) {
    var next_level = current_level.nextElementSibling;

    // check if another level is available, if so deactivate
    if(next_level) {
        next_level.classList.remove('service-finder__element--active');
        next_level.querySelector('.progress-decoration').classList.remove('progress-decoration--active');

        // Check whether second level is available (topics) & whether there are active elements (selected topics, reset buttons), if yes -> deactivate
        var themes = next_level.querySelector('.service-finder_themes-target--active');
        if(themes) {
            showSiblings('service-finder_result-button');
            hideServiceLevel('.service-finder_themes-target');

            if(next_level.querySelector('.reset-button--active')) {
                next_level.querySelector('.reset-button--active').classList.remove('reset-button--active');
            }
        }
        hideResultLevel();

        // if there is a next level -> call the function again
        if(next_level.nextElementSibling) {
            hideLowerLevels(next_level);
        }
    }
}

function deactivateParent(element) {
    document.getElementById(element).closest(".service-finder__element").classList.remove('service-finder__element--active');
}

function hideSiblings(element, sibilings_class) {
    document.querySelectorAll('.' + sibilings_class).forEach(function(sibling) {
        if(!sibling.classList.contains(sibilings_class + '--active')) {
            sibling.classList.add(sibilings_class + '--hidden');
        }
    });
}

function showSiblings(sibilings_class) {
    document.querySelectorAll('.' + sibilings_class).forEach(function(sibling) {
        sibling.classList.remove(sibilings_class + '--hidden');
        sibling.classList.remove(sibilings_class + '--active');
    });
}

function recalcDecoration(currentLevel, nextLevel) {
    document.querySelector("#" + currentLevel + " .progress-decoration").classList.remove('progress-decoration--active');
    document.querySelector("#" + nextLevel + " .progress-decoration").classList.add('progress-decoration--active');
    document.getElementById(nextLevel).classList.add('service-finder__element--active');
}

function getServiceElements(url, targetdivid) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
            document.getElementById(targetdivid).innerHTML = this.responseText;
        }
    };
    xhttp.open("GET", url, true);
    xhttp.send();
}
